import React, { useMemo } from 'react';
import { Tab as HeadlessTab } from '@headlessui/react';
import './Tab.css';
import { Theme } from './Theme';
import { twMerge } from 'tailwind-merge';
/**
 * A styled and opinionated version of Headless UI's Tab components.
 *
 * A `Tab.Group` is the outermost component that wraps a `Tab.List` and `Tab.Panels`.
 *
 * `Tab.List` contains one or more `Tab`s.
 *
 * `Tab.Panels` contains one or more `Tab.Panel`s. Panels are not styled. The number of tabs and panels should match.
 * @constructor
 */
export default function Tab(props) {
  const {
    label,
    theme = Theme.LightMode
  } = props;
  const {
    baselineClassNames,
    selectedClassNames,
    unselectedClassNames
  } = useMemo(() => ({
    baselineClassNames: twMerge('storywind-tab', 'inline-flex flex-col items-center', 'mx-1 px-5 first:ml-0 last:mr-0 py-0.5', 'rounded-full focus:outline-none border-none', 'text-base', theme === Theme.LightMode && 'text-gray-900 active:bg-gray-400', theme === Theme.DarkMode && 'text-gray-200 active:bg-blue-700'),
    selectedClassNames: twMerge('font-bold', theme === Theme.LightMode && 'bg-gray-300', theme === Theme.DarkMode && 'bg-blue-500'),
    unselectedClassNames: twMerge(theme === Theme.LightMode && 'hover:bg-gray-200')
  }), [theme]);
  return /*#__PURE__*/React.createElement(HeadlessTab, {
    "data-text": label,
    className: ({
      selected
    }) => twMerge(baselineClassNames, selected ? selectedClassNames : unselectedClassNames)
  }, label);
}
Tab.Group = function Group(props) {
  return /*#__PURE__*/React.createElement(HeadlessTab.Group, props);
};
Tab.List = function List(props) {
  return /*#__PURE__*/React.createElement(HeadlessTab.List, props);
};
Tab.Panels = function Panels(props) {
  return /*#__PURE__*/React.createElement(HeadlessTab.Panels, props);
};
Tab.Panel = function Panel(props) {
  return /*#__PURE__*/React.createElement(HeadlessTab.Panel, props);
};